import { SvgIcon, Text } from '@cinch-labs/design-system'
import { trackFooterLinkClick } from '../tracking'
import { readFromEnv } from '@cinch-nx/environments'
import styles from './help-and-support-cta.module.css'

const HelpAndSupportCta = () => {
  const helpAndSupportURL = readFromEnv('HELP_AND_SUPPORT_URL')

  const targetLinkText = 'Visit our help centre'

  return (
    <a
      className={styles.container}
      href={helpAndSupportURL}
      onClick={() => trackFooterLinkClick(helpAndSupportURL, targetLinkText)}
      target="_blank"
    >
      <Text
        lineHeight="display"
        fontSizeFixed="xxl"
        fontWeight="semibold"
        element="span"
        className={styles.heading}
      >
        Got a question?
      </Text>
      <Text
        fontSizeFixed="xs"
        fontWeight="medium"
        element="span"
        className={styles.subHeading}
      >
        See our FAQs and get in touch
      </Text>
      <Text
        lineHeight="display"
        fontSizeFixed="s"
        element="span"
        className={styles.linkLabel}
      >
        {targetLinkText}{' '}
        <SvgIcon name="external-link" className={styles.linkIcon} />
      </Text>
    </a>
  )
}

export default HelpAndSupportCta
